<div
	class="h-full pb-[100px] px-12px relative custom-filter"
	[formGroup]="filterForm"
>
	<div class="flex justify-between items-center py-24px">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" class="flex text-link" (click)="resetFilter()">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>

	<div>
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'WALLET.WALLET_LIST.ORGSNAME' | translate }}
		</p>
		<mat-form-field
			[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
			class="w-full"
			appearance="outline"
			(click)="showList = !showList"
		>
			<mat-label>{{ 'GENERAL_LABELS.SEARCH_ORGSNAME' | translate }}</mat-label>
			<input type="text" matInput [formControl]="keyWord" />

			<img
				*ngIf="!keyWord?.value"
				class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
				src="assets/images/arrow.png"
			/>

			<img
				(click)="
					keyWord.setValue('');
					keyWordBranch.setValue('');
					filterForm.controls['serviceProviderId'].setValue(null);
					filterForm.controls['branchId'].setValue(null);
					branchesList = []
				"
				*ngIf="keyWord?.value"
				src="./assets/images/close-square.svg"
				class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
			/>
		</mat-form-field>
		<ul class="autoCompleteList" *ngIf="showList">
			<li
				*ngFor="let name of serviceProviders"
				(click)="
					getController('serviceProviderId').setValue(name.id);
					keyWord.setValue(name?.name);
					getBranches();
					showList = !showList
				"
			>
				{{ name?.name }}
			</li>
			<li *ngIf="!serviceProviders?.length && showList" class="text-center">
				{{ 'GENERAL.NO_BUSINESS_NAME_FOUND' | translate }}
			</li>
		</ul>
	</div>
	<div class="w-100 h-[1px] bg-secondry-color-Gray my-24px"></div>
	<div>
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'BOOKING.BOOKING_DETAILS.BRANCH_NAME' | translate }}
		</p>
		<mat-form-field
			[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
			class="w-full"
			appearance="outline"
			(click)="showBranchList = !showBranchList"
		>
			<mat-label>{{
				'GENERAL_LABELS.SEARCH_BRANCH_NAME' | translate
			}}</mat-label>
			<input type="text" matInput [formControl]="keyWordBranch" />
			<img
				*ngIf="!keyWordBranch?.value"
				class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
				src="assets/images/arrow.png"
			/>

			<img
				(click)="keyWordBranch.setValue('')"
				*ngIf="keyWordBranch?.value"
				src="./assets/images/close-square.svg"
				class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
			/>
		</mat-form-field>
		<ul class="autoCompleteList" *ngIf="showBranchList">
			<li
				*ngFor="let name of branchesList"
				(click)="
					getController('branchId').setValue(name.id);
					keyWordBranch.setValue(name?.name);
					getBranches();
					showBranchList = !showBranchList
				"
			>
				{{ name?.name }}
			</li>
			<li *ngIf="!branchesList?.length && showBranchList" class="text-center">
				{{ 'GENERAL.BRANCH_NAME_FOUND' | translate }}
			</li>
		</ul>
	</div>

	<button
		[disabled]="filterCount == 0"
		class="bg-gradient text-white w-full p-0 absolute bottom-5`"
		mat-button
		(click)="submit()"
	>
		{{ 'ACTIONS.APPLY_FILTER' | translate }}
	</button>
</div>
